interface EmailHtmlPreviewProps {
  html: string
  title?: string
}

const EXTERNAL_PROTOCOLS = new Set(['http', 'https', 'mailto'])
const BLOCKED_PROTOCOLS = new Set(['javascript', 'data', 'vbscript'])

function hrefProtocol(href: string): string {
  let compact = ''
  for (let i = 0; i < href.length; i++) {
    const char = href[i]
    if (char == null) continue
    const code = char.charCodeAt(0)
    if (code <= 32 || code === 127) continue
    compact += char
  }
  const protocol = /^([a-z][a-z0-9+.-]*):/i.exec(compact)?.[1]
  return protocol ? protocol.toLowerCase() : ''
}

function readHref(tag: string): string | null {
  const match = /\shref\s*=\s*(?:"([^"]*)"|'([^']*)'|([^\s>]+))/i.exec(tag)
  if (!match) return null
  return match[1] ?? match[2] ?? match[3] ?? ''
}

function rewriteAnchor(tag: string): string {
  const href = readHref(tag)
  if (href == null) return tag
  const protocol = hrefProtocol(href)
  if (BLOCKED_PROTOCOLS.has(protocol)) {
    return tag.replace(/\shref\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/i, ' href="#"')
  }
  const trimmed = href.trim()
  if (!trimmed || trimmed.startsWith('#')) return tag
  if (protocol && !EXTERNAL_PROTOCOLS.has(protocol)) return tag
  const stripped = tag.replace(/\s(?:target|rel)\s*=\s*(?:"[^"]*"|'[^']*'|[^\s>]+)/gi, '')
  return stripped.replace(/>$/, ' target="_blank" rel="noopener noreferrer">')
}

function rewritePreviewHtml(html: string): string {
  return html.replace(/<a\b[^>]*>/gi, rewriteAnchor)
}

export function EmailHtmlPreview({ html, title = 'E-Mail-Vorschau' }: EmailHtmlPreviewProps) {
  return (
    <iframe
      title={title}
      sandbox="allow-popups allow-popups-to-escape-sandbox"
      srcDoc={rewritePreviewHtml(html)}
      className="w-full border-0 bg-white block"
      style={{ minHeight: 480, height: 640 }}
    />
  )
}
